/* ============================================================
   ÉPRIS Page-Transition + Loader — Unified Overlay
   ============================================================
   Ein einziges Overlay-Element handlet:
   - Internal-Link-Click: 200ms white fade → navigate → fade-out auf neuer Page
   - Form-Submit (search/account/contact): fade-overlay MIT ÉPRIS-Logo-Loader
   - pageshow-Event: hidet overlay zuverlässig

   Funktioniert in JEDEM Browser (kein View-Transitions-API nötig).
   Premium feel ohne JS-Lifecycle-Library-Overhead.

   Public API:
     window.eprisLoader.show({ withLoader: bool })
     window.eprisLoader.hide()

   Skip-Logic für Links:
   - external (host !== location.host)
   - target=_blank, download
   - cart/checkout/api paths (auth-state-relevant)
   - Modifier keys (cmd/ctrl/shift/alt) → user wants new tab
   ============================================================ */

(function() {
  'use strict';

  let overlay = null;
  let navigating = false;
  let failsafeTimer = null;

  function ensure() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'epris-nav-fade';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = `
      <div class="epris-nav-fade__loader">
        <div class="epris-nav-fade__stage">
          <span class="epris-nav-fade__ring"></span>
          <span class="epris-nav-fade__ring"></span>
          <img class="epris-nav-fade__logo" src="https://cdn.shopify.com/s/files/1/0782/7400/3287/files/Logo.svg?v=1729751366" alt="">
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    return overlay;
  }

  function show(opts) {
    opts = opts || {};
    const el = ensure();
    if (navigating && !opts.force) return;
    navigating = true;
    el.classList.toggle('show-loader', !!opts.withLoader);
    el.classList.add('is-visible');
    el.setAttribute('aria-hidden', 'false');
    /* Failsafe: spätestens nach 8s automatisch hide
       (verhindert "stuck loader" wenn navigation cancelled) */
    clearTimeout(failsafeTimer);
    failsafeTimer = setTimeout(hide, 8000);
  }

  function hide() {
    if (!overlay) return;
    navigating = false;
    overlay.classList.remove('is-visible', 'show-loader');
    overlay.setAttribute('aria-hidden', 'true');
    clearTimeout(failsafeTimer);
  }

  window.eprisLoader = {
    show: (o) => show(o),
    hide: hide
  };

  /* ---------- Link-Click → Nav-Fade ---------- */
  function shouldTransition(a) {
    if (!a.href || a.target === '_blank') return false;
    if (a.hasAttribute('download')) return false;
    if (a.host !== location.host) return false;
    if (a.protocol !== 'http:' && a.protocol !== 'https:') return false;
    if (a.pathname === location.pathname && a.search === location.search) {
      /* Hash-only-link (anchor) → no transition */
      return false;
    }
    /* Skip cart/checkout/account/api Pfade — auch mit Locale-Prefix wie /nl-nl/cart.
       Vorher: nur ^/cart matched → /nl-nl/cart wurde intercepted → Theme's
       AJAX-Cart-Remove + meine Nav liefen parallel → Shopify error. */
    if (/(?:^|\/)(cart|checkout|account|api)(?:\/|$)/.test(a.pathname)) return false;
    if (a.dataset.noTransition !== undefined) return false;
    /* Skip Drawer/Modal-Trigger (haben aria-controls) — z.B. Search-Icon,
       Cart-Icon, Menu-Hamburger. Das sind keine Page-Navigations sondern
       JS-handlers die ein Drawer/Modal öffnen. */
    if (a.hasAttribute('aria-controls')) return false;
    /* Skip role=button (semantisch eh kein link) */
    if (a.getAttribute('role') === 'button') return false;
    return true;
  }

  document.addEventListener('click', (e) => {
    /* Skip wenn ein anderer Handler den Click bereits behandelt hat
       (z.B. Wishlist-Heart-Click ruft preventDefault — wir würden sonst
       trotzdem zur Card-PDP navigieren). */
    if (e.defaultPrevented) return;
    /* Modifier-keys oder middle-click → user wants new tab, kein intercept */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (e.button !== 0 && e.button !== undefined) return;
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a || !shouldTransition(a)) return;
    e.preventDefault();
    show({ withLoader: false });
    /* Navigate nach Fade-Duration (200ms CSS) */
    setTimeout(() => {
      window.location.href = a.href;
    }, 180);
  }, true);

  /* ---------- Form-Submit → Fade + Loader ---------- */
  function shouldShowFor(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.dataset.eprisLoader === 'false') return false;
    if (form.hasAttribute('data-epris-loader')) return true;
    const action = (form.getAttribute('action') || '').toLowerCase();
    if (!action) return false;
    return /\/search|\/account\/(login|register|recover|reset)|\/contact/.test(action);
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!shouldShowFor(form)) return;
    show({ withLoader: true });
  }, true);

  /* ---------- Page-Lifecycle: hide on entry ---------- */
  /* pageshow feuert auch bei back/forward cache restore — wichtig
     damit overlay nicht über new page hängen bleibt */
  window.addEventListener('pageshow', () => hide());

  /* Wenn user via back/forward navigiert ohne JS unload, sicherheitshalber */
  window.addEventListener('beforeunload', () => {
    /* keep overlay visible during nav, wird beim pageshow auf new page gehide't */
  });
})();
